export function urlParams (obj) {
  if (!obj) {
    return '';
  }
  let output = '?';
  Object.keys(obj).forEach(key => {
    output += key + '=' + obj[key] + '&';
  });
  output = output.substr(0, output.length - 1);
  return output;
}

export function getAdresseringFromVejkodeObjekt (vejkode) {
  if (!vejkode) {
    return;
  }
  let postnummer = '';
  if (vejkode.postnumre && vejkode.postnumre.length) {
    postnummer += vejkode.postnumre[0].nr + ' ' + vejkode.postnumre[0].navn;
    if (vejkode.postnumre.length > 1) {
      postnummer += ' (m.fl.)';
    }
  }
  return {
    navn: vejkode.navn,
    postnr: postnummer,
  };
}

export function getAdresseringStringFromVejkodeObjekt (vejkode) {
  if (!vejkode) {
    return '';
  }
  const { navn, postnr } = getAdresseringFromVejkodeObjekt(vejkode);
  return `${navn}, ${postnr}`;
}

export function arrayToCommaSeparatedString (array) {
  if (!array) {
    return undefined;
  }
  return array.reduce((accumulated, curr, i) => i === 0 ? curr : accumulated + ',' + curr, '');
}

export function getInitials (navn) {
  if (!navn) {
    return '';
  }
  const navnArray = navn.split(' ');
  if (navnArray.length === 1) {
    return navn.substr(0, 1);
  }
  return navnArray[0].substr(0, 1) + navnArray[navnArray.length - 1].substr(0, 1);
}
